import { SVGProps } from "react";

export const ChangeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "14"} height={props.height || "15"} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.1251 7.5C13.1251 10.8828 10.3828 13.625 7.00006 13.625C4.45211 13.625 2.26753 12.0692 1.34448 9.85577" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M0.875 7.5C0.875 4.11726 3.61726 1.375 7 1.375C9.54795 1.375 11.7326 2.9308 12.6555 5.14423" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.1251 2.78845V5.14422H10.7693" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M0.875 12.2115V9.85577H3.23077" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
